module.exports = __webpack_public_path__ + "img/img29.f864e428.svg";